module.exports = __webpack_public_path__ + "img/logo.e854a30a.png";